var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('review-dashboard',{attrs:{"experiments-url":_vm.experimentsUrl,"fields":_vm.fields,"modal-fields":_vm.modalFields,"modal-details-fields":_vm.modalDetailsFields,"report-fields":_vm.reportFields,"shifts-config":_vm.shiftsConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }